import React, {useEffect, useState} from "react";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ButtonPrimary from "../../../components/button-primary/ButtonPrimary";

import ShopIcon from '../../../static/icons/shop.svg';
import ShopMobileIcon from '../../../static/icons/shop_mobile.svg';

import FabricIcon from '../../../static/icons/fabric.svg';
import FabricMobileIcon from '../../../static/icons/fabric_mobile.svg';

import MachineIcon from '../../../static/icons/machine.svg';
import MachineMobileIcon from '../../../static/icons/machine_mobile.svg';

import MarketingIcon from '../../../static/icons/marketing.svg';
import MarketingMobileIcon from '../../../static/icons/marketing_mobile.svg';

import CompanyIcon from '../../../static/icons/company.svg';
import CompanyMobileIcon from '../../../static/icons/company_mobile.svg';

import HouseIcon from '../../../static/icons/house.svg';
import HouseMobileIcon from '../../../static/icons/house_mobile.svg';
import {VEDMARKET_LINKS} from '../../../constants';

import styles from './Business.module.scss';

function Business() {

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const cards = [
        {
            text: <span>Онлайн-магазины и&nbsp;ритейл, продавцы маркетплейсов</span>,
            image: isMobile ? ShopMobileIcon : ShopIcon,
        },
        {
            text: <span>Предприятия, закупающие сырье для производства</span> ,
            image: isMobile ? FabricMobileIcon : FabricIcon,
        },
        {
            text: <span>Производители, импортирующие оборудование и&nbsp;запчасти</span>,
            image: isMobile ? MachineMobileIcon : MachineIcon,
        },
        {
            text: <span>Отделы маркетинга, закупающие сувенирную продукцию</span>,
            image: isMobile ? MarketingMobileIcon : MarketingIcon,
        },
        {
            text: <span>Компании с&nbsp;продукцией под&nbsp;собственным брендом</span>,
            image: isMobile ? CompanyMobileIcon : CompanyIcon,
        },
        {
            text: <span>Частные лица, заказывающие доставку нестандартных товаров</span>,
            image: isMobile ? HouseMobileIcon : HouseIcon,
        }
    ]


    return (
        <div className={styles.business}>
            <Container className={styles.businessContainer}>
                <Row>
                    <Col xxl={{ span: 6, offset: 6 }}>
                        <h2 className={styles.title}>
                            Подойдет для вашего бизнеса
                        </h2>
                        <p className={styles.subtitle}><b>Вэдмаркет</b> позволяет точно определить стоимость товаров на&nbsp;складе еще до&nbsp;размещения заказа у&nbsp;производителя.</p>
                        <ButtonPrimary href={VEDMARKET_LINKS.calculator} target="_blank" rel="noreferrer" label="Перейти к расчетам" isWide/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <div  className={styles.cardsContainer}>
                            {cards.map((card, index) => (
                                <div className={styles.card} key={index}>
                                    <div className={styles.cardContainer}>
                                        <h3 className={styles.cardTitle}>{card.text}</h3>
                                        <img src={card.image} alt=""  className={styles.cardImage}/>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Business;
